module.exports = __webpack_public_path__ + "static/media/Circo2025_01.348aaa3b.webp";